var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6868 35.31V19.2074C43.6868 15.8419 42.2789 14.1587 39.463 14.1577C36.6472 14.1567 35.2363 15.84 35.2303 19.2074V35.31H26.9111V19.2074C26.9111 15.8419 25.5248 14.1587 22.7522 14.1577C19.9314 14.1577 18.5235 15.841 18.5285 19.2074V35.31H10.2078V18.257C10.2078 14.7437 11.4447 12.0848 13.9186 10.2801C16.0968 8.66871 19.0414 7.86304 22.7522 7.86304C26.5143 7.86304 29.2859 8.81448 31.0669 10.7174C32.6015 8.81448 35.3982 7.86304 39.457 7.86304C43.1679 7.86304 46.1114 8.66871 48.2876 10.2801C50.7615 12.0838 51.9989 14.7428 51.9999 18.257V35.31H43.6868Z",
    fill: "#F98012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.359 6.62258L34.6164 0.672984L34.5108 0.310059C19.6101 2.1113 12.8341 3.38749 0 10.7233L0.119169 11.0565L1.1389 11.0669C1.04537 12.0799 0.882456 14.5831 1.09062 18.3478C-0.333372 22.4113 1.05442 25.1719 2.35774 28.175C2.5644 25.0515 2.54328 21.6304 1.57032 18.2258C1.36667 14.4865 1.53412 12.0278 1.62613 11.0714L10.1339 11.1517C10.111 12.7945 10.1952 14.4369 10.3858 16.0691C17.9885 18.7032 25.635 16.0601 29.6943 9.56615C28.5674 8.32119 26.359 6.62258 26.359 6.62258Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodleActive);
export default __webpack_public_path__ + "static/media/moodle-active.6732833f3e8ad05bfe61322d8b4eb3a2.svg";
export { ForwardRef as ReactComponent };